<script setup lang="ts">
import { storeToRefs } from "pinia";

import { useProject } from "@/stores/project/project.store";

import GroupTypeContainer from "./GroupTypeContainer.vue";
import GroupMaterialContainer from "./GroupMaterialContainer.vue";

import { useModalStore } from "@/stores/modals/modals.store";
import { Material } from "@/types/Views/MaterialDatabase/Material";

const modals = useModalStore();

const projectStore = useProject();
const { isGroupingByType } = storeToRefs(projectStore);

const props = defineProps<{
  prefillMaterial?: Material;
}>();
</script>

<template>
  <div class="text-text-color mr-2 flex h-full flex-col pr-2">
    <div class="flex flex-col gap-6">
      <GroupTypeContainer
        v-if="isGroupingByType"
        :prefill-material="props.prefillMaterial"
        @toggle-modal="() => modals.close()" />
      <GroupMaterialContainer
        v-else
        :prefill-material="props.prefillMaterial"
        @toggle-modal="() => modals.close()" />
    </div>
  </div>
</template>
